export const wrapperStyles = {
  display: 'flex',
  flexDirection: 'column',
  gap: '12px',
};

export const headStyles = {
  display: 'flex',
  alignItems: 'center',
  gap: '8px',
};

// TODO: replace with SX
const avatarStyles = {
  height: '40px',
  width: '40px',
  fontSize: '1.4rem',
  fontWeight: 700,
  fontFamily: 'Roboto, sans-serif !important',
  color: '#4D627B',
  border: '2px solid #EAEAEA !important',
  backgroundColor: ({ palette }) => palette.background.paper,
};

export const headTextContent = {
  display: 'flex',
  flexDirection: 'column',
  justifyContent: 'center',
  gap: '4px',
};

export const titleStyles = {
  color: ({ palette }) => palette.text.primary,
  fontSize: '1.4rem',
  lineHeight: '2.2rem',
  fontWeight: 500,
};

export const descriptionStyles = {
  fontSize: '1.2rem',
  color: ({ palette }) => palette.text.secondary,
};

export const buttonStyles = {
  alignSelf: 'end',
  padding: '2px 8px',
  width: 'fit-content',
  fontSize: '1.2rem',
  fontWeight: 400,
  textTransform: 'none',
  borderRadius: '6px',
  backgroundColor: '#108FEB',
  boxShadow: 'none !important',
};

export const getStyles = () => ({
  wrapper: wrapperStyles,
  head: headStyles,
  avatar: avatarStyles,
  headTextContent,
  title: titleStyles,
  description: descriptionStyles,
  button: buttonStyles,
});
